import { Cookie } from '@pco/atoms/Cookie';
import { ZIP_CODE_COOKIE } from '@pco/constants/cookies';
import { useEffect } from 'react';

export const ZipCodeSetup = () => {
	useEffect(() => {
		const [_, setCookie] = Cookie(ZIP_CODE_COOKIE);
		const urlParams = new URLSearchParams(window.location.search);
		const zipCode = urlParams.get('zipCode');
		if (zipCode) {
			setCookie(zipCode);
			urlParams.delete('zipCode');

			// Check if there are other parameters left
			const newQueryString = urlParams.toString();
			const newUrl = newQueryString
				? `${window.location.pathname}?${newQueryString}`
				: window.location.pathname;

			window.history.replaceState(null, '', newUrl);
		}
	}, []);
	return null;
};

export default ZipCodeSetup;
